import { useCallback, useState } from "react";

import { History } from "lucide-react";
import { Button, DefaultPopover, DefaultTooltip } from "twyne-new.ui";

import { ChangeHistoryProvider } from "../store";

import ChangeHistory from "./Versions";

function Popover({ entityName, entityCollection, loading }) {
  const [open, setOpen] = useState(false)

  const onOpenChange = useCallback(open => {
    if (loading) return;
    setOpen(open)
  }, [loading])

  return <DefaultPopover
    wrapperProps={{ open, onOpenChange }}
    contentProps={{ className: "w-80 p-0 overflow-y-hidden", side: "bottom", align: "end" }}
    trigger={<Trigger loading={loading} />}
  >
    <Content open={open} entityName={entityName} entityCollection={entityCollection} />
  </DefaultPopover>
}

function Content({ open, entityName, entityCollection }) {
  if (!open) {
    return null;
  }
  return <ChangeHistory entityName={entityName} entityCollection={entityCollection} />
}

function Trigger({ loading }) {
  return <DefaultTooltip content="History Versions">
    <Button className="items-center h-8" color="accent" variant="outline" disabled={loading}>
      <History size={16} />
    </Button>
  </DefaultTooltip>
}

export default function DefaultChangeHistory(props) {
  return <ChangeHistoryProvider>
    <Popover {...props} />
  </ChangeHistoryProvider>
}
